import type { Seo } from '~/types/common';
import { wrapPiniaStore } from '@devhacker/shared/utils/wrapPiniaStore';
import { defineStore } from 'pinia';

export const DEFAULT_SEO = {
  title: 'Горящая Изба',
  description: 'Горящая изба - Женское издание про всё',
  robots: '',
  canonical: '',
  og_image: '',
  site_icon: '/android-chrome-512x512.png',
};

export const useSeoStore = wrapPiniaStore(
  defineStore('seo', {
    state: () => ({
      byPath: {} as Record<string, Seo>,
    }),

    getters: {
      currentSeo(state) {
        const route = useRoute(); // Using Nuxt's route via useNuxtApp
        const currentPath = route.fullPath.replace(route.hash, '');
        return state.byPath[String(currentPath)] ?? DEFAULT_SEO;
      },
    },

    actions: {
      addSeoByPath(path: string, seo: Seo) {
        // TODO: Check if reactivity working without vue set
        this.byPath[path] = seo;
      },
    },
  }),
);
